import { render, staticRenderFns } from "./CodForm.vue?vue&type=template&id=3562558d"
import script from "./CodForm.vue?vue&type=script&lang=js"
export * from "./CodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports